import "./Teachers.module.css";
import Header from "@/reusable_sections/Header";
import Philosophy from "./sections/Philosophy";
import Team from "./sections/Team";
import PathwayProgress from "./sections/PathwayProgress";
import SmallGroupLearningModel from "./sections/SmallGroupLearningModel";
import TeachingApproach from "./sections/TeachingApproach";
import LearningEnvironment from "./sections/LearningEnvironment";
import ParentExpectations from "./sections/ParentExpectations";
import ClosingCTA from "./sections/ClosingCTA";
import Footer from "@/reusable_sections/Footer";
export default function TeachersPage() {
  return <div>
      <Header />
      <Philosophy />
      <Team />
      <PathwayProgress />
      <SmallGroupLearningModel />
      <TeachingApproach />
      <LearningEnvironment />
      <ParentExpectations />
      <ClosingCTA />
      <Footer />
    </div>;
}